import * as React from 'react';
import { createStylesForBreakpoints, } from '../helpers/breakpoint';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
/**
 * @deprecated the AspectRatio enum is deprecated. Please use one of the string values instead.
 */
export var AspectRatio;
(function (AspectRatio) {
    AspectRatio["1:1"] = "1:1";
    AspectRatio["1:2"] = "1:2";
    AspectRatio["10:6"] = "10:6";
    AspectRatio["16:9"] = "16:9";
    AspectRatio["2:1"] = "2:1";
    AspectRatio["2:3"] = "2:3";
    AspectRatio["3:2"] = "3:2";
    AspectRatio["3:4"] = "3:4";
    AspectRatio["4:3"] = "4:3";
    AspectRatio["4:5"] = "4:5";
    AspectRatio["6:5"] = "6:5";
    AspectRatio["9:16"] = "9:16";
})(AspectRatio || (AspectRatio = {}));
const StyledWrapper = styled.div.withConfig({ displayName: "StyledWrapper", componentId: "sc-iw10kj" }) `position:relative;width:100%;height:0;${createAspectRatioForBreakpoints};&& > *{position:absolute;top:0;left:0;width:100%;height:100%;}`;
StyledWrapper.displayName = 'StyledWrapper';
function createAspectRatioForBreakpoints(props) {
    if (!props.ratio) {
        return '';
    }
    return createStylesForBreakpoints(props.ratio, (ratio) => `padding-bottom: ${calcAspectRatio(ratio) * 100}%;`);
}
/**
 * Calculates numeric ratio.
 * @param ratio - aspect ratio definition
 */
export function calcAspectRatio(ratio) {
    const [width, height] = ratio.split(':');
    return Number(height) / Number(width);
}
export const AspectRatioContainer = (props) => {
    const { ratio, children } = props;
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledWrapper, Object.assign({ ratio: ratio }, commonProps), children));
};
AspectRatioContainer.displayName = 'AspectRatioContainer';
